function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import './_stamped-reviews-summary.scss';
var REVIEWS_PAGE_SIZE = 5;
var reviewsPaginationState = new WeakMap();
function toPositiveInt(value, fallback) {
  var parsed = Number.parseInt(value, 10);
  if (!Number.isFinite(parsed) || parsed <= 0) return fallback;
  return parsed;
}
function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}
function toNumber(value) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
}
function normalizeToPercentages(inputMap) {
  var stars = [1, 2, 3, 4, 5];
  var values = {};
  var total = 0;
  var maybePercent = true;
  stars.forEach(star => {
    var value = Math.max(0, toNumber(inputMap[star], 0));
    values[star] = value;
    total += value;
    if (value > 100) maybePercent = false;
  });
  if (total <= 0) {
    return {
      1: 0,
      2: 0,
      3: 0,
      4: 0,
      5: 0
    };
  }
  if (maybePercent && total <= 100.5) {
    return {
      1: Math.round(values[1]),
      2: Math.round(values[2]),
      3: Math.round(values[3]),
      4: Math.round(values[4]),
      5: Math.round(values[5])
    };
  }
  return {
    1: Math.round(values[1] * 100 / total),
    2: Math.round(values[2] * 100 / total),
    3: Math.round(values[3] * 100 / total),
    4: Math.round(values[4] * 100 / total),
    5: Math.round(values[5] * 100 / total)
  };
}
function toDistributionMap(rawDistribution) {
  var base = {
    1: 0,
    2: 0,
    3: 0,
    4: 0,
    5: 0
  };
  if (!rawDistribution) return base;
  if (Array.isArray(rawDistribution)) {
    rawDistribution.forEach(entry => {
      var _entry$star, _ref, _ref2, _entry$value;
      var star = toPositiveInt((_entry$star = entry === null || entry === void 0 ? void 0 : entry.star) !== null && _entry$star !== void 0 ? _entry$star : entry === null || entry === void 0 ? void 0 : entry.rating, NaN);
      if (star < 1 || star > 5) return;
      var value = (_ref = (_ref2 = (_entry$value = entry === null || entry === void 0 ? void 0 : entry.value) !== null && _entry$value !== void 0 ? _entry$value : entry === null || entry === void 0 ? void 0 : entry.count) !== null && _ref2 !== void 0 ? _ref2 : entry === null || entry === void 0 ? void 0 : entry.percentage) !== null && _ref !== void 0 ? _ref : entry === null || entry === void 0 ? void 0 : entry.percent;
      base[star] = toNumber(value, 0);
    });
    return base;
  }
  if (typeof rawDistribution === 'object') {
    [1, 2, 3, 4, 5].forEach(star => {
      var _ref3, _ref4, _rawDistribution$star;
      base[star] = toNumber((_ref3 = (_ref4 = (_rawDistribution$star = rawDistribution[star]) !== null && _rawDistribution$star !== void 0 ? _rawDistribution$star : rawDistribution[String(star)]) !== null && _ref4 !== void 0 ? _ref4 : rawDistribution["".concat(star, "_star")]) !== null && _ref3 !== void 0 ? _ref3 : rawDistribution["".concat(star, "Star")], 0);
    });
  }
  return base;
}
function extractReviewsArray(payload) {
  var _payload$data, _payload$data2, _payload$result;
  if (!payload || typeof payload !== 'object') return [];
  return payload.reviews || payload.items || ((_payload$data = payload.data) === null || _payload$data === void 0 ? void 0 : _payload$data.reviews) || ((_payload$data2 = payload.data) === null || _payload$data2 === void 0 ? void 0 : _payload$data2.items) || ((_payload$result = payload.result) === null || _payload$result === void 0 ? void 0 : _payload$result.reviews) || [];
}
function formatReviewDate(value) {
  if (!value) return '';
  var parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return String(value);
  }
  return parsed.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}
function normalizeReviews(reviews) {
  return reviews.map(entry => {
    var review = (entry === null || entry === void 0 ? void 0 : entry.review) || entry || {};
    var rawDate = review.dateCreated || review.createdAt || review.date || '';
    var dateTimestamp = Date.parse(rawDate);
    return {
      author: String(review.author || 'Anonymous').trim(),
      rating: clamp(Math.round(toNumber(review.rating, 0)), 1, 5),
      body: String(review.body || '').trim(),
      dateCreated: formatReviewDate(rawDate),
      dateTimestamp: Number.isFinite(dateTimestamp) ? dateTimestamp : 0
    };
  }).filter(review => review.body || review.rating || review.author);
}
function hideReviewsList(root) {
  var toolbar = root.querySelector('[data-reviews-toolbar]');
  var wrapper = root.querySelector('[data-reviews-list-wrapper]');
  var list = root.querySelector('[data-reviews-list]');
  var loadMore = root.querySelector('[data-reviews-load-more]');
  var listEmpty = root.querySelector('[data-reviews-list-empty]');
  if (toolbar) toolbar.hidden = true;
  if (wrapper) wrapper.hidden = true;
  if (loadMore) loadMore.hidden = true;
  if (listEmpty) listEmpty.hidden = true;
  if (list) list.innerHTML = '';
}
function createReviewItem(review, isLast) {
  var item = document.createElement('li');
  item.className = 'stamped-reviews-summary__review-item';
  var header = document.createElement('div');
  header.className = 'stamped-reviews-summary__review-header';
  var author = document.createElement('p');
  author.className = 'stamped-reviews-summary__review-author';
  author.textContent = review.author || 'Anonymous';
  var rating = document.createElement('div');
  rating.className = 'stamped-reviews-summary__review-rating';
  rating.setAttribute('aria-label', "".concat(review.rating, " out of 5 stars"));
  for (var star = 1; star <= 5; star += 1) {
    var starNode = document.createElement('span');
    var isFilled = star <= review.rating;
    starNode.className = "stamped-reviews-summary__review-star".concat(isFilled ? ' stamped-reviews-summary__review-star--filled' : '');
    starNode.textContent = '★';
    rating.append(starNode);
  }
  header.append(author, rating);
  item.append(header);
  var body = document.createElement('p');
  body.className = 'stamped-reviews-summary__review-body text--body-large';
  body.textContent = review.body || '';
  item.append(body);
  if (review.dateCreated) {
    var date = document.createElement('p');
    date.className = 'stamped-reviews-summary__review-date text--body-small';
    date.textContent = review.dateCreated;
    item.append(date);
  }
  if (!isLast) {
    var separator = document.createElement('div');
    separator.className = 'stamped-reviews-summary__review-separator';
    item.append(separator);
  }
  return item;
}
function renderNextReviewPage(root) {
  var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var state = reviewsPaginationState.get(root);
  if (!state) return;
  var list = root.querySelector('[data-reviews-list]');
  var listEmpty = root.querySelector('[data-reviews-list-empty]');
  var wrapper = root.querySelector('[data-reviews-list-wrapper]');
  var loadMore = root.querySelector('[data-reviews-load-more]');
  if (!list || !wrapper || !loadMore || !listEmpty) return;
  if (!state.reviews.length) {
    // Only show the "no matches" message when the emptiness is
    // filter-induced; with no reviews at all the section-level empty
    // message ([data-reviews-empty]) already covers it.
    var isFilterInduced = state.allReviews.length > 0;
    wrapper.hidden = !isFilterInduced;
    list.innerHTML = '';
    listEmpty.hidden = !isFilterInduced;
    loadMore.hidden = true;
    return;
  }
  if (reset) {
    state.renderedCount = 0;
    list.innerHTML = '';
  }
  var start = state.renderedCount;
  var end = Math.min(start + REVIEWS_PAGE_SIZE, state.reviews.length);
  var pageReviews = state.reviews.slice(start, end);
  pageReviews.forEach((review, index) => {
    var absoluteIndex = start + index;
    var isLast = absoluteIndex === state.reviews.length - 1;
    list.append(createReviewItem(review, isLast));
  });
  state.renderedCount = end;
  wrapper.hidden = false;
  listEmpty.hidden = true;
  loadMore.hidden = state.renderedCount >= state.reviews.length;
}
function closeAllFilters(root) {
  root.querySelectorAll('[data-filter-root]').forEach(details => {
    details.open = false;
  });
}
function applyReviewFilters(root) {
  var state = reviewsPaginationState.get(root);
  if (!state) return;
  var filtered = [...state.allReviews];
  if (state.ratingFilter !== 'all') {
    var rating = toPositiveInt(state.ratingFilter, 0);
    filtered = filtered.filter(review => review.rating === rating);
  }
  if (state.sortBy === 'rating-desc') {
    filtered.sort((a, b) => {
      if (b.rating !== a.rating) return b.rating - a.rating;
      return b.dateTimestamp - a.dateTimestamp;
    });
  } else {
    filtered.sort((a, b) => b.dateTimestamp - a.dateTimestamp);
  }
  state.reviews = filtered;
  renderNextReviewPage(root, true);
}
function bindFilterControls(root) {
  var state = reviewsPaginationState.get(root);
  if (!state || state.filtersBound) return;
  var sortLabel = root.querySelector('[data-sort-label]');
  var ratingLabel = root.querySelector('[data-rating-label]');
  root.querySelectorAll('[data-sort-option]').forEach(button => {
    button.addEventListener('click', () => {
      var nextValue = button.getAttribute('data-sort-option') || 'most-recent';
      state.sortBy = nextValue;
      if (sortLabel) {
        sortLabel.textContent = nextValue === 'rating-desc' ? 'Highest Rating' : 'Most Recent';
      }
      closeAllFilters(root);
      applyReviewFilters(root);
    });
  });
  root.querySelectorAll('[data-rating-option]').forEach(button => {
    button.addEventListener('click', () => {
      var nextValue = button.getAttribute('data-rating-option') || 'all';
      state.ratingFilter = nextValue;
      if (ratingLabel) {
        ratingLabel.textContent = nextValue === 'all' ? 'All stars' : "".concat(nextValue, " ").concat(nextValue === '1' ? 'star' : 'stars');
      }
      closeAllFilters(root);
      applyReviewFilters(root);
    });
  });
  state.filtersBound = true;
}
function bindLoadMore(root) {
  var loadMore = root.querySelector('[data-reviews-load-more]');
  if (!loadMore || loadMore.dataset.bound === 'true') return;
  loadMore.addEventListener('click', () => {
    renderNextReviewPage(root, false);
  });
  loadMore.dataset.bound = 'true';
}
function renderReviews(root, reviews) {
  var toolbar = root.querySelector('[data-reviews-toolbar]');
  reviewsPaginationState.set(root, {
    allReviews: reviews,
    reviews: [],
    renderedCount: 0,
    sortBy: 'most-recent',
    ratingFilter: 'all',
    filtersBound: false
  });
  if (toolbar) {
    toolbar.hidden = reviews.length === 0;
  }
  bindLoadMore(root);
  bindFilterControls(root);
  applyReviewFilters(root);
}
function computeFromReviews(reviews) {
  var map = {
    1: 0,
    2: 0,
    3: 0,
    4: 0,
    5: 0
  };
  var totalScore = 0;
  var totalCount = 0;
  reviews.forEach(review => {
    var _ref5, _ref6, _review$review$rating, _review$review;
    var rawRating = (_ref5 = (_ref6 = (_review$review$rating = review === null || review === void 0 || (_review$review = review.review) === null || _review$review === void 0 ? void 0 : _review$review.rating) !== null && _review$review$rating !== void 0 ? _review$review$rating : review === null || review === void 0 ? void 0 : review.rating) !== null && _ref6 !== void 0 ? _ref6 : review === null || review === void 0 ? void 0 : review.score) !== null && _ref5 !== void 0 ? _ref5 : review === null || review === void 0 ? void 0 : review.stars;
    var rating = clamp(Math.round(toNumber(rawRating, 0)), 1, 5);
    if (!rating) return;
    map[rating] += 1;
    totalScore += rating;
    totalCount += 1;
  });
  return {
    distribution: map,
    totalReviews: totalCount,
    averageRating: totalCount ? totalScore / totalCount : 0
  };
}
function extractReviewMetrics(payload) {
  var _payload$data3, _payload$result2, _payload$data4, _payload$result3, _ref7, _ref8, _ref9, _ref0, _ref1, _summary$total, _payload$pagination, _payload$meta, _ref10, _ref11, _ref12, _summary$averageRatin, _payload$data5;
  var summary = (payload === null || payload === void 0 ? void 0 : payload.summary) || (payload === null || payload === void 0 || (_payload$data3 = payload.data) === null || _payload$data3 === void 0 ? void 0 : _payload$data3.summary) || (payload === null || payload === void 0 || (_payload$result2 = payload.result) === null || _payload$result2 === void 0 ? void 0 : _payload$result2.summary) || {};
  var distributionRaw = summary.distribution || summary.breakdown || (payload === null || payload === void 0 ? void 0 : payload.distribution) || (payload === null || payload === void 0 || (_payload$data4 = payload.data) === null || _payload$data4 === void 0 ? void 0 : _payload$data4.distribution) || (payload === null || payload === void 0 || (_payload$result3 = payload.result) === null || _payload$result3 === void 0 ? void 0 : _payload$result3.distribution);
  var distribution = toDistributionMap(distributionRaw);
  var totalReviews = toNumber((_ref7 = (_ref8 = (_ref9 = (_ref0 = (_ref1 = (_summary$total = summary.total) !== null && _summary$total !== void 0 ? _summary$total : summary.totalReviews) !== null && _ref1 !== void 0 ? _ref1 : summary.reviewCount) !== null && _ref0 !== void 0 ? _ref0 : payload === null || payload === void 0 ? void 0 : payload.totalReviews) !== null && _ref9 !== void 0 ? _ref9 : payload === null || payload === void 0 ? void 0 : payload.reviewCount) !== null && _ref8 !== void 0 ? _ref8 : payload === null || payload === void 0 || (_payload$pagination = payload.pagination) === null || _payload$pagination === void 0 ? void 0 : _payload$pagination.total) !== null && _ref7 !== void 0 ? _ref7 : payload === null || payload === void 0 || (_payload$meta = payload.meta) === null || _payload$meta === void 0 ? void 0 : _payload$meta.total, 0);
  var averageRating = toNumber((_ref10 = (_ref11 = (_ref12 = (_summary$averageRatin = summary.averageRating) !== null && _summary$averageRatin !== void 0 ? _summary$averageRatin : summary.average) !== null && _ref12 !== void 0 ? _ref12 : payload === null || payload === void 0 ? void 0 : payload.averageRating) !== null && _ref11 !== void 0 ? _ref11 : payload === null || payload === void 0 ? void 0 : payload.rating) !== null && _ref10 !== void 0 ? _ref10 : payload === null || payload === void 0 || (_payload$data5 = payload.data) === null || _payload$data5 === void 0 ? void 0 : _payload$data5.averageRating, 0);
  var reviews = extractReviewsArray(payload);
  var distributionHasData = Object.values(distribution).some(value => value > 0);
  if (!distributionHasData || !totalReviews || !averageRating) {
    var computed = computeFromReviews(reviews);
    if (!distributionHasData) {
      distribution = computed.distribution;
    }
    if (!totalReviews) {
      totalReviews = computed.totalReviews;
    }
    if (!averageRating) {
      averageRating = computed.averageRating;
    }
  }
  return {
    distribution: normalizeToPercentages(distribution),
    totalReviews: Math.max(0, Math.round(totalReviews)),
    averageRating: Math.max(0, averageRating)
  };
}
function renderMetrics(root, metrics) {
  var averageNode = root.querySelector('[data-reviews-average]');
  var countNode = root.querySelector('[data-reviews-count]');
  var distributionNode = root.querySelector('[data-reviews-distribution]');
  var emptyNode = root.querySelector('[data-reviews-empty]');
  var hasDistribution = Object.values(metrics.distribution || {}).some(value => toNumber(value, 0) > 0);
  var hasReviews = metrics.totalReviews > 0;
  if (!hasReviews) {
    if (averageNode) {
      averageNode.textContent = 'No reviews yet';
    }
    if (countNode) {
      countNode.textContent = '';
    }
    if (distributionNode) {
      distributionNode.hidden = true;
    }
    if (emptyNode) {
      emptyNode.hidden = false;
      emptyNode.textContent = 'No reviews yet for this product.';
    }
    hideReviewsList(root);
    return;
  }
  if (averageNode) {
    averageNode.textContent = "".concat(metrics.averageRating.toFixed(1), " out of 5 stars");
  }
  if (countNode) {
    countNode.textContent = "Based on ".concat(metrics.totalReviews, " reviews");
  }
  if (distributionNode) {
    distributionNode.hidden = !hasDistribution;
  }
  if (emptyNode) {
    emptyNode.hidden = true;
  }
  [1, 2, 3, 4, 5].forEach(star => {
    var percent = clamp(Math.round(toNumber(metrics.distribution[star], 0)), 0, 100);
    var fillNode = root.querySelector("[data-star-fill=\"".concat(star, "\"]"));
    var percentNode = root.querySelector("[data-star-percent=\"".concat(star, "\"]"));
    var progressNode = root.querySelector("[data-star-progress=\"".concat(star, "\"]"));
    if (fillNode) fillNode.style.width = "".concat(percent, "%");
    if (percentNode) percentNode.textContent = "".concat(percent, "%");
    if (progressNode) progressNode.setAttribute('aria-valuenow', String(percent));
  });
}
function renderUnavailable(root) {
  var averageNode = root.querySelector('[data-reviews-average]');
  var countNode = root.querySelector('[data-reviews-count]');
  var distributionNode = root.querySelector('[data-reviews-distribution]');
  var emptyNode = root.querySelector('[data-reviews-empty]');
  if (averageNode) {
    averageNode.textContent = 'Reviews unavailable';
  }
  if (countNode) {
    countNode.textContent = '';
  }
  if (distributionNode) {
    distributionNode.hidden = true;
  }
  if (emptyNode) {
    emptyNode.hidden = false;
    emptyNode.textContent = 'We could not load reviews right now.';
  }
  hideReviewsList(root);
}
function hydrateReviews(_x) {
  return _hydrateReviews.apply(this, arguments);
}
function _hydrateReviews() {
  _hydrateReviews = _asyncToGenerator(function* (root) {
    var handle = (root.dataset.handle || '').trim();
    if (!handle) return;
    var apiBaseUrl = (root.dataset.apiBaseUrl || '').trim();
    if (!apiBaseUrl) return;
    var page = toPositiveInt(root.dataset.page, 1);
    var take = clamp(toPositiveInt(root.dataset.take, 10), 1, 20);
    var sort = (root.dataset.sort || 'most-recent').trim() || 'most-recent';
    var endpointUrl;
    try {
      endpointUrl = new URL('/api/reviews', apiBaseUrl);
    } catch (error) {
      console.error('Stamped reviews summary: invalid API base URL.', error);
      return;
    }
    endpointUrl.searchParams.set('handle', handle);
    endpointUrl.searchParams.set('page', String(page));
    endpointUrl.searchParams.set('take', String(take));
    endpointUrl.searchParams.set('sort', sort);
    try {
      var response = yield fetch(endpointUrl.toString(), {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        }
      });
      if (!response.ok) {
        throw new Error("Failed to fetch reviews (".concat(response.status, ")"));
      }
      var payload = yield response.json();
      var metrics = extractReviewMetrics(payload);
      var reviews = normalizeReviews(extractReviewsArray(payload));
      renderMetrics(root, metrics);
      renderReviews(root, reviews);
    } catch (error) {
      console.error('Stamped reviews summary: request failed.', error);
      renderUnavailable(root);
    }
  });
  return _hydrateReviews.apply(this, arguments);
}
function initStampedReviewsSummary() {
  var roots = document.querySelectorAll('[data-stamped-reviews-summary]');
  roots.forEach(root => {
    hydrateReviews(root);
  });
}
document.addEventListener('DOMContentLoaded', initStampedReviewsSummary);
document.addEventListener('shopify:section:load', initStampedReviewsSummary);